module.exports = __webpack_public_path__ + "images/banners/guidance_slider_modal/pc_ba7d6ea6d4182a30e2e1c9a07bce7bdb.webp";